import { render, staticRenderFns } from "./CalcItem.vue?vue&type=template&id=10c4e04e&scoped=true&"
import script from "./CalcItem.vue?vue&type=script&lang=js&"
export * from "./CalcItem.vue?vue&type=script&lang=js&"
import style0 from "./CalcItem.vue?vue&type=style&index=0&id=10c4e04e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4e04e",
  null
  
)

export default component.exports